import React from "react";
import P from "prop-types";
import styled from "@emotion/styled";
import Spinner from "../UI/Misc/Spinner";
import ListHeader from "./ListHeader";
import { FormattedMessage, injectIntl } from "react-intl";
import getLangData from "../../utils/getLangData";

const List = ({ children, isLoading, header, items }) => (
	<div className="table-responsive p-3 my-5">
		{header && <ListHeader items={header.items} />}
		{children}
		{isLoading && <Spinner />}
		{!isLoading && (!items || items.length === 0) && (
			<div className="kt-widget31__item">
				<NoItems className="kt-widget31__text">
					{getLangData().fields.no_items}

				</NoItems>
			</div>
		)}
	</div>
);

const NoItems = styled.div`
	margin: 0;
	font-size: 18px;
	text-align: center;
	width: 100%;
	font-weight: bold;
	opacity: 0.5;
`;

List.propTypes = {
	children: P.oneOfType([P.arrayOf(P.node), P.node]).isRequired,
	isLoading: P.bool,
	header: P.shape({
		items: P.array,
		actions: P.array,
	}),
	items: P.array,
};

List.defaultProps = {
	isLoading: false,
};

export default injectIntl(List);
